<template>
    <!-- 三方票映射管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'thirdTicketManage')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="三方平台类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['thirdType']" @select="search">
                            <a-select-option value="DY">抖音</a-select-option>
                            <a-select-option value="MT">美团</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="sku_id">
                        <a-input placeholder="请输入" v-decorator="['skuId']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="loading" @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <a-button slot="extra" type="primary" @click="openModal({id: '',thirdType: undefined})">新增</a-button>
                <a-table
                :scroll="{y: 560}"
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="(record, index) => index"
                >
                <template slot="thirdType" slot-scope="key">{{key ? (key == 'DY' ? '抖音' : '美团') : '--'}}</template>
                <span slot="action" slot-scope="a,row">
                    <a class="text-primary" @click="openModal(row)">编辑</a>
                    <a-divider type="vertical" />
                    <a-popconfirm
                        title="请确认是否要删除？删除后会导致已购买用户无法闸机核销入园，若票券已过有效期可删除"
                        @confirm="deleteSku(row.id)"
                        >
                        <a class="text-primary">删除</a>
                    </a-popconfirm>
                </span>
                </a-table>
            </a-card>
            <a-modal
            centered
            :title="editItem.id ? '编辑' : '新增'"
            :width="700"
            :visible="visible"
            :destroyOnClose="true"
            :confirmLoading="confirmLoading"
            @cancel="visible = false"
            @ok="save"
            >
                <a-form :form="formModal">
                    <a-form-item v-if="editItem.shopName ? editItem.shopName : shopName" label="适用门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        {{editItem.shopName ? editItem.shopName : shopName}}
                    </a-form-item>
                    <a-form-item label="三方平台类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select :disabled="!!editItem.id" placeholder="请选择" v-decorator="['thirdType',{initialValue: editItem.id ? editItem.thirdType : undefined,rules: [{required: true, message: '请选择'}]}]" @change="onChangeThirdType">
                            <a-select-option value="DY">抖音</a-select-option>
                            <a-select-option value="MT">美团</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="选择sku" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select show-search v-decorator="['skuId',{rules: [{required: true, message: '请选择（输入skuId搜索）'}]}]" placeholder="请选择（输入skuId搜索）">
                            <a-select-option :vlaue="item.skuId" v-for="item in skuList" :key="item.skuId">
                                {{item.skuName}}
                                <a-badge aria-labal :color="item.hasMapping ? '#A60A0A' : '#62D18E'" :text="item.skuId" />
                            </a-select-option>
                        </a-select>
                        <div v-show="formModal.getFieldValue('skuId')">选中的skuId：{{formModal.getFieldValue('skuId')}}</div>
                    </a-form-item>
                    <a-form-item label="成人数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number
                            style="width:100%"
                            :min="0"
                            :precision="0"
                            placeholder="请输入"
                            v-decorator="['adultCount',{rules: [{required: true, message: '请输入',}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="儿童数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number
                            style="width:100%"
                            :min="0"
                            :precision="0"
                            placeholder="请输入"
                            v-decorator="['childCount',{rules: [{required: true, message: '请输入',}]}]"
                        />
                    </a-form-item>
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: "exchangeGiftOrder",
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: "sku_id",
                    dataIndex: "skuId",
                },
                {
                    title: 'sku名称',
                    dataIndex: 'skuName'
                },
                {
                    title: '成人数量',
                    dataIndex: 'adultCount'
                },
                {
                    title: '儿童数量',
                    dataIndex: 'childCount',
                },
                {
                    title: '第三方平台类型',
                    dataIndex: 'thirdType',
                    scopedSlots: { customRender: "thirdType" }
                },
                {
                    title: '适用门店',
                    dataIndex: 'shopName',
                },
                {
                    title: "操作",
                    key: "action",
                    scopedSlots: { customRender: "action" },
                }
            ];
            return {
                labelCol: {span: 5},
                wrapperCol: {span: 19},
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                visible: false,
                confirmLoading: false,
                skuList: [],
                editItem: {},
            };
        },
        computed: {
            ...mapGetters(["shopId","shopName"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.shopTicket.thirdGoodsNameMappingList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId == -1 ? undefined : this.shopId
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
                });
            },
            getSkuList(thirdType) {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.shopTicket.findAllCategoryGroupQuery({
                        body: {
                            thirdType: thirdType,
                            shopId: this.editItem.shopId ? this.editItem.shopId : this.shopId
                        }
                    }).then(res => {
                        this.skuList = res;
                    })
                });
            },
            onChangeThirdType(e) {
                this.formModal.setFieldsValue({skuId: undefined})
                this.getSkuList(e)
            },
            save() {
                this.formModal.validateFields((err, values) => {
                    if (err) return;
                    this.confirmLoading = true;
                    this.$api.shopTicket[this.editItem.id ? 'findAllCategoryGroupEdit' : 'findAllCategoryGroupAdd']({
                        body: Object.assign(values, {
                            id: this.editItem.id,
                            skuName: this.skuList.filter(e => e.skuId == values.skuId)[0].skuName,
                            shopId: this.editItem.shopId ? this.editItem.shopId : this.shopId,
                            shopName: this.editItem.shopName ? this.editItem.shopName : this.shopName,
                        })
                    })
                    .then(res => {
                        this.$message.success('操作成功');
                        this.confirmLoading = false;
                        this.visible = false;
                        this.getList();
                    })
                    .catch(err => {
                        this.confirmLoading = false;
                    })
                });
            },
            openModal(item={}) {
                this.editItem = item;
                this.skuList = [];
                if(item.id) {
                    this.getSkuList(item.thirdType);
                    this.$nextTick(() =>{
                        this.formModal.setFieldsValue(item);
                    })
                }else {
                    if(this.shopId == -1) {
                        this.$message.warning('总平台不支持新增映射关系，请切换至具体门店再新增')
                        return
                    }
                }
                this.visible = true;
            },
            deleteSku(id) {
                this.$api.shopTicket.findAllCategoryGroupDelete({
                    body: {
                        id: id
                    }
                }).then(res => {
                    this.getList();
                    this.$message.success('操作成功');
                })
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.formModal = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {
            shopId() {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>